/**
 * A date string the API actually set. .NET's default DateTime is year 1 and is stored
 * on fields that were never assigned (publishedDate is one of those). That value is
 * not a date we should display, and it must not beat a real created date.
 */
function usableDate(value) {
  if (typeof value !== "string" || value.length === 0 || value.startsWith("0001-")) {
    return null;
  }
  return value;
}

/**
 * Date an in-site ACR was added. Published wins over created. The API has sent both
 * casings, so both are accepted. Shared by the product form and the listing date column.
 */
export default function inSiteAcrAddedOn(report) {
  if (!report) {
    return null;
  }
  return usableDate(report.publishedDate)
    || usableDate(report.PublishedDate)
    || usableDate(report.createdDate)
    || usableDate(report.CreatedDate)
    || null;
}

/** Date an in-site ACR was last updated. The API has sent both casings. */
export function inSiteAcrUpdatedOn(report) {
  if (!report) {
    return null;
  }
  return usableDate(report.lastModifiedDate) || usableDate(report.LastModifiedDate) || null;
}
